

/* Scheme List */
export const GET_SCHEME_LIST = "GET_SCHEME_LIST";
export const GET_SCHEME_LIST_SUCCESS =
  "GET_SCHEME_LIST_SUCCESS";
export const GET_SCHEME_LIST_FAIL = "GET_SCHEME_LIST_FAIL";

/////////////////////////////
///get analytes associated with unit
export const GET_SCHEMEANALYTE = "GET_SCHEMEANALYTE";
export const GET_SCHEMEANALYTE_SUCCESS ="GET_SCHEMEANALYTE_SUCCESS";
export const GET_SCHEMEANALYTE_FAIL = "GET_SCHEMEANALYTE_FAIL";

///get analytes associated with unit
export const GET_SCHEMENAME = "GET_SCHEMENAME";
export const GET_SCHEMENAME_SUCCESS ="GET_SCHEMENAME_SUCCESS";
export const GET_SCHEMENAME_FAIL = "GET_SCHEMENAME_FAIL";

///adding new Scheme
export const ADD_NEW_SCHEME_LIST = "ADD_NEW_SCHEME_LIST";
export const ADD_NEW_SCHEME_LIST_SUCCESS = "ADD_NEW_SCHEME_LIST_SUCCESS";
export const ADD_NEW_SCHEME_LIST_FAIL = "ADD_NEW_SCHEME_LIST_FAIL";

//update Scheme
export const UPDATE_NEW_SCHEME_LIST = "UPDATE_NEW_SCHEME_LIST";
export const UPDATE_NEW_SCHEME_LIST_SUCCESS = "UPDATE_NEW_SCHEME_LIST_SUCCESS";
export const UPDATE_NEW_SCHEME_LIST_FAIL = "UPDATE_NEW_SCHEME_LIST_FAIL";

// Delete Scheme
export const DELETE_SCHEME = "DELETE_SCHEME";
export const DELETE_SCHEME_SUCCESS = "DELETE_SCHEME_SUCCESS";
export const DELETE_SCHEME_FAIL = "DELETE_SCHEME_FAIL";

export const GET_PURCHASED_SCHEME = "GET_PURCHASED_SCHEME";
export const GET_PURCHASED_SCHEME_SUCCESS = "GET_PURCHASED_SCHEME_SUCCESS";
export const GET_PURCHASED_SCHEME_FAIL = "GET_PURCHASED_SCHEME_FAIL";

export const GET_COA_CRITERIA_LIST = "GET_COA_CRITERIA_LIST";
export const GET_COA_CRITERIA_LIST_SUCCESS ="GET_COA_CRITERIA_LIST_SUCCESS";
export const GET_COA_CRITERIA_LIST_FAIL = "GET_COA_CRITERIA_LIST_FAIL";

export const SUBMIT_COA_PARTICIPANTS         = "SUBMIT_COA_PARTICIPANTS";
export const SUBMIT_COA_PARTICIPANTS_SUCCESS = "SUBMIT_COA_PARTICIPANTS_SUCCESS";
export const SUBMIT_COA_PARTICIPANTS_FAIL    = "SUBMIT_COA_PARTICIPANTS_FAIL";

export const GET_COA_SUBMITTED_LIST         = "GET_COA_SUBMITTED_LIST";
export const GET_COA_SUBMITTED_LIST_SUCCESS = "GET_COA_SUBMITTED_LIST_SUCCESS";
export const GET_COA_SUBMITTED_LIST_FAIL    = "GET_COA_SUBMITTED_LIST_FAIL";

export const GET_STOCK_LIST = "GET_STOCK_LIST";
export const GET_STOCK_LIST_SUCCESS = "GET_STOCK_LIST_SUCCESS";
export const GET_STOCK_LIST_FAIL = "GET_STOCK_LIST_FAIL";

export const ADD_STOCK = "ADD_STOCK";
export const ADD_STOCK_SUCCESS = "ADD_STOCK_SUCCESS";
export const ADD_STOCK_FAIL = "ADD_STOCK_FAIL";

export const UPDATE_STOCK = "UPDATE_STOCK";
export const UPDATE_STOCK_SUCCESS = "UPDATE_STOCK_SUCCESS";
export const UPDATE_STOCK_FAIL = "UPDATE_STOCK_FAIL";